module.exports = __webpack_public_path__ + "img/Abfahrk_status_leichterMangel.eca33fae.svg";